import { RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B030020FindRequest = { seikyushimeYmd: string } & Partial<{
  urikakeshainCd: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B030020FindResponse = {
  seikyushimeshoriKbn: string;
  seikyushimeYmd: string;
  nyukinYmd: string;
  urikakeshainNm: string;
  updDate: string;
  updshainNm: string;
  seikyushimeNo: string;
  seikyushimeStatus: string;
};

export const B030020Find = (props: B030020FindRequest) => {
  return RestClient.get<PageableResponse<B030020FindResponse[]>>(
    "b030020/find",
    {
      params: props,
    }
  );
};

export type B030020GetSeikyujokenRequest = {
  seikyushimeNo: string;
};

export type B030020GetSeikyujokenResponse = {
  seikyushimeNo: string;
  seikyushimeshoriKbn: number;
  seikyushimeYmd: string;
  seikyuYmd: string;
  nyukinYmd: string;
  urikakeshainCd: string;
  urikakeshainNm: string;
  seikyujokenKbn: string;
  seikyucdFrom1: string;
  seikyushitencdFrom1: string;
  seikyunmFrom1: string;
  seikyucdTo1: string;
  seikyushitencdTo1: string;
  seikyunmTo1: string;
  seikyucdFrom2: string;
  seikyushitencdFrom2: string;
  seikyunmFrom2: string;
  seikyucdTo2: string;
  seikyushitencdTo2: string;
  seikyunmTo2: string;
  seikyucdFrom3: string;
  seikyushitencdFrom3: string;
  seikyunmFrom3: string;
  seikyucdTo3: string;
  seikyushitencdTo3: string;
  seikyunmTo3: string;
  seikyucdFrom4: string;
  seikyushitencdFrom4: string;
  seikyunmFrom4: string;
  seikyucdTo4: string;
  seikyushitencdTo4: string;
  seikyunmTo4: string;
  seikyucd1: string;
  seikyushitencd1: string;
  seikyunm1: string;
  seikyucd2: string;
  seikyushitencd2: string;
  seikyunm2: string;
  seikyucd3: string;
  seikyushitencd3: string;
  seikyunm3: string;
  seikyucd4: string;
  seikyushitencd4: string;
  seikyunm4: string;
  seikyucd5: string;
  seikyushitencd5: string;
  seikyunm5: string;
  seikyucd6: string;
  seikyushitencd6: string;
  seikyunm6: string;
  seikyucd7: string;
  seikyushitencd7: string;
  seikyunm7: string;
  seikyucd8: string;
  seikyushitencd8: string;
  seikyunm8: string;
  seikyucd9: string;
  seikyushitencd9: string;
  seikyunm9: string;
  seikyucd10: string;
  seikyushitencd10: string;
  seikyunm10: string;
  seikyucd11: string;
  seikyushitencd11: string;
  seikyunm11: string;
  seikyucd12: string;
  seikyushitencd12: string;
  seikyunm12: string;
  seikyucd13: string;
  seikyushitencd13: string;
  seikyunm13: string;
  seikyucd14: string;
  seikyushitencd14: string;
  seikyunm14: string;
  seikyucd15: string;
  seikyushitencd15: string;
  seikyunm15: string;
  seikyucd16: string;
  seikyushitencd16: string;
  seikyunm16: string;
  seikyucd17: string;
  seikyushitencd17: string;
  seikyunm17: string;
  seikyucd18: string;
  seikyushitencd18: string;
  seikyunm18: string;
  seikyucd19: string;
  seikyushitencd19: string;
  seikyunm19: string;
  seikyucd20: string;
  seikyushitencd20: string;
  seikyunm20: string;
  taishoseikyuKensu: string;
  taishouridenpyoKensu: string;
  taishonyukindenpyoKensu: string;
  seikyushimeStatus: number;
  version: string;
};

export const B030020GetSeikyujoken = (props: B030020GetSeikyujokenRequest) => {
  return RestClient.get<B030020GetSeikyujokenResponse>("b030020/get", {
    params: props,
  });
};
